import React from "react";
import {UserContentBase} from "./UserContentBase";
import UserProfileInfo from "./UserProfileInfo";


export class UserProfileContent extends UserContentBase {
    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("fourth")}
                <div className="section-body h-items">
                    <UserProfileInfo
                        userId={this.props.userId}
                        afterSuccessfulSubmit={this.handleAfterSuccessfulUserUpdated}
                    />
                </div>
            </section>
        )
    }
}
